import axios from "./axiosinstance";

const AuthApi = {
  login: (payload) => axios.post("auths/login", payload),
  refresh: (payload) => axios.post("auths/refresh", payload),
  logout: () => axios.post("auths/logout"),
};

export default AuthApi;
